import { render, staticRenderFns } from "./QQCarrello.vue?vue&type=template&id=f3919ee6&scoped=true&"
import script from "./QQCarrello.vue?vue&type=script&lang=js&"
export * from "./QQCarrello.vue?vue&type=script&lang=js&"
import style0 from "./QQCarrello.vue?vue&type=style&index=0&id=f3919ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3919ee6",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QIcon,QItemSection,QSeparator});
